import {storageAvailable} from '../base/utils';

class Alert {
    KEY = 'alert';

    constructor($alert) {
        this.$alert = $alert;

        if (!this.$alert)
            return;

        this.check();
        this.init();
    }

    init() {
        this.$close = this.$alert.querySelector('.js-alert-close');

        if (this.$close) {
            this.$close.addEventListener('click', () => {
                this.$alert.classList.add('alert-hidden');

                if (storageAvailable('localStorage')) {
                    try {
                        let key = window.localStorage.getItem(this.KEY),
                            ids = key ? JSON.parse(key) : [];

                        ids.push(this.$alert.id);
                        window.localStorage.setItem(this.KEY, JSON.stringify(ids));
                    } catch (e) {
                        console.error(e);
                    }
                }
            });
        }
    }

    check() {
        if (storageAvailable('localStorage')) {
            let ids = window.localStorage.getItem(this.KEY) || [];

            if (ids.indexOf(this.$alert.id) < 0) {
                this.$alert.classList.remove('alert-hidden');
            }
        }
    }
}

export default Alert;
